import { useState } from 'react';

import { reverseAreaAt, type AreaSearchResult, type GeoType } from '../../../../api/regions';

/**
 * Click-to-add for the region builder map: resolve the clicked point to the
 * containing area of `level` (Nominatim reverse-geocode), enforce the parent
 * bounds, and hand the area to `addComp`. Exposes a status message for the UI.
 */
export function useMapAreaAdd(
  regionId: string,
  level: GeoType,
  addComp: (area: AreaSearchResult) => void,
) {
  const [message, setMessage] = useState<string | null>(null);

  async function onMapClick(lat: number, lon: number) {
    setMessage(`Resolving ${level}…`);
    try {
      const { result, withinParent } = await reverseAreaAt(lat, lon, level, regionId);
      if (!result) {
        setMessage(`No ${level} found at that point.`);
        return;
      }
      if (!withinParent) {
        setMessage(`${result.label} is outside the parent region — not added.`);
        return;
      }
      addComp(result);
      setMessage(`Added ${result.label}.`);
    } catch {
      setMessage('Could not resolve that point — try again.');
    }
  }

  return { onMapClick, message };
}
